'use strict';
var defineWellKnownSymbol = require('../internals/well-known-symbol-define');

// `Symbol.observable` well-known symbol
// https://github.com/tc39/proposal-observable
defineWellKnownSymbol('observable');



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/esnext.symbol.observable.js
// module id = 1526
// module chunks = 0